import { IUpdateBancoPagamentoUseCase } from "../../../presentation/useCases/update/update_banco_pagamento_use_case";
import { BancoPagamento } from "../../models/banco_pagamento";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * UpdateBancoPagamentoUseCase
 */

export class UpdateBancoPagamentoUseCase implements IUpdateBancoPagamentoUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async updateBancoPagamento(form: BancoPagamento): Promise<void> {
    await this.repository.updateBancoPagamento(form);

  }
}
